module.exports = __webpack_public_path__ + "static/media/20_ans.06de015d.mp3";